/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const DisableMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type DisableMonitoringIntegrationHeaders = zod.input<
  typeof DisableMonitoringIntegrationHeaders
>;
export type DisableMonitoringIntegrationHeadersOutput = zod.output<
  typeof DisableMonitoringIntegrationHeaders
>;
